import React from 'react'
import styled, { css } from 'styled-components'

export const HeroContainerStyled = styled.div`
  width: 100%;
  height: fit-content;
  position:relative;
  background-color: #000000;

  ${({ mb }) => mb && css`
    margin-bottom: ${mb};
  `}

  @media (min-width: 567px) {
    height: auto;
    margin-bottom: 0;
  }
`

export const HeroContainer = (props) => {
  return (
    <HeroContainerStyled {...props}>
      {props.children}
    </HeroContainerStyled>
  )
}

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 20px 5vw 0px;

    @media (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      padding: 0px 40px 0px;
    }
`

export const Title = styled.h1`
  margin: 0px;
  text-align: left;
  font-weight: 800;
  font-size: 32px;
  line-height: 1.2;
  color: #4EF6CE;
  margin-bottom: 20px;
  max-width: 350px;

  ${props => props.theme?.rtl && css`
      text-align: right;
  `}

  @media (min-width: 768px) {
    font-size: 40px;
    margin-bottom: 40px;
    max-width: 100%;
  }
`

export const AddressBox = styled.div`
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: 0px 0px 25px rgba(255, 255, 255, 0.6),
  0 15px 40px rgba(0, 0, 0, 0.08);
  width: 100%;
  box-sizing: border-box;
  max-width: 650px;
  border-color: #45e0b7;
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
  z-index: 100;
  .address-label {
    font-weight: 800;
    font-size:16px;
    margin-top: 0;
    margin-bottom: 25px;
    color: #000;
  }

  .signin-label {
    font-size: 16px;
    color: #000;
    margin: 0;
    margin-top: 25px;
    font-weight: 800;
    span {
      color: #3EE0BA;
      cursor: pointer;
    }
  }
`

export const WrapInput = styled.div`
  position: relative;
  cursor: pointer;
  background: #FFFFFF;
  padding: 8px 8px 8px 24px;
  border: none;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    flex: 1;
    color: #7A7A7A;
    font-weight: 600;
    position: relative;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    text-align: left;
  }

  svg {
    color: #3EE0BA;
    font-size: 24px;
    margin-right: 15px;
    ${props => props.theme?.rtl && css`
       margin-left: 15px;
       margin-right: 0;
    `}
  }

  .search-btn {
    background: linear-gradient(to right, #10FFBD, #89FFDF) !important;
    border: none !important;
    color: #000;
    border-radius: 50px;
    font-weight: 800;
    padding: 12px 24px;
    margin: 0;
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    box-shadow: 0px 5px 0px #1AF1B8 !important;
    position: relative;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(2px);
      box-shadow: 0px 3px 0px #1AF1B8 !important;
    }

    &:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px #1AF1B8 !important;
    }
  }
`

export const LogoWrapper = styled.div`
  display: none;
`

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px 0 0 0;

  @media (min-width: 768px) {
    width: 50%;
    padding: 60px 0 60px 0px;
  }
`

export const BurgerImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 20px;
  z-index: 1;
  img {
    width: 100%;
    max-width: 500px;
    height: auto;
    object-fit: contain;
  }

  @media (min-width: 768px) {
    width: 50%;
    margin-top: 0;
    height: 100%;
    align-items: center;
    img {
      max-width: 600px;
    }
  }
`

export const PoweredByOrdering = styled.div`
  text-align: center;
  margin-top: 10px;
  a {
    font-weight: 600;
    margin-left: 5px;
    text-decoration: none;
  }
`
export const UseAccount = styled.div`
  display: none;
`
export const SectionHeader = styled.div`
  display: none;
`
